import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LocalLoadEvent } from '../../../shared/local-load-event.model';
import * as moment from 'moment';
import { Moment } from 'moment';

@Component({
  selector: 'app-load-event-checkin',
  templateUrl: './load-event-checkin.component.html',
  styleUrls: ['./load-event-checkin.component.scss']
})
export class LoadEventCheckinComponent implements OnInit, OnChanges {

  @Input()
  event: LocalLoadEvent;

  value: Moment;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.event) {
      this.updateValue();
    }
  }

  updateValue() {
    this.value = this.event.newValue ? moment(this.event.newValue) : null;
  }

}
